import * as React from "react";
import { ContentPicker } from "../components/ContentPicker";
import { ImagePicker } from "../components/ImagePicker";
import { ContentViewModel, EntityTypes, ImageTypes, ListContent } from "../content/ContentStore";
import { Button } from "grommet";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const AliasProfilePicker = ({ onSelect, disabled, uri, children }) => {
    const [options, setOptions] = React.useState([] as ContentViewModel[]);

    React.useEffect(() => {
        ListContent(ImageTypes.Logo, EntityTypes.Alias, 0, 50).then((res) => {
            setOptions(res.result);
        });
    }, []);

    return (
        <ContentPicker label="Profile" onSelect={onSelect} uri={uri} width="150px" options={options} optionWidth="65px" optionHeight="65px" suggestedSize="128px x 128px" optionsPageSize={18} disabled={disabled} maxWidth={800}>
            {children}
        </ContentPicker>
    );
};

export default AliasProfilePicker;
